//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
let d=[[[0,"PartNumber",1,0]],[[[],"GetOwner",{R_:{owner:"Mechatronics.SystemObject"}},0,0],[["owner"],"SetOwner",{},1,0],[["num"],"GetAttributes",{R_:{attribute:""}},0,0],[["attribute"],"SetAttributes",{},1,0]],[]];
SPLM.Mechatronics.ElectricalPartBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.ElectricalPartBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.ElectricalPartBuilder.Attribute = class{
    constructor(attribute_name,attribute_value){
        this.attribute_name=attribute_name;this.attribute_value=attribute_value;}
    get AttributeName(){return this.attribute_name}
    set AttributeName(val){this.attribute_name = val}
    get AttributeValue(){return this.attribute_value}
    set AttributeValue(val){this.attribute_value = val}
};

export default SPLM;